export const LINKS = {
  fresha: "https://www.fresha.com/de/lvp/nabil-barbershop-saarlandstrasse-bochum-k9ox5b",
  tiktok: "https://www.tiktok.com/@nabil_barbershop",
  maps: "https://maps.google.com/?q=Nabil+Barbershop,+Saarlandstra%C3%9Fe+5,+44866+Bochum-Wattenscheid",
  mapsEmbed: "https://maps.google.com/maps?q=Nabil%20Barbershop%20Saarlandstra%C3%9Fe%205%2044866%20Bochum&t=&z=15&ie=UTF8&iwloc=&output=embed",
};

export const INFO = {
  address: "Saarlandstraße 5",
  city: "44866 Bochum-Wattenscheid",
  hoursWeek: "Mo – Fr 09:00 – 19:00 Uhr",
  hoursSat: "Sa 09:00 – 18:00 Uhr",
  tiktokHandle: "@nabil_barbershop",
};

export const IMAGES = {
  hero: "https://static.prod-images.emergentagent.com/jobs/67a2085c-9103-4d7b-bd52-e2a4c1531583/images/203e685a79518314f903f46b3c02be7965b4399558b3bcd1c8a149ac1823d4fb.png",
  portrait: "https://static.prod-images.emergentagent.com/jobs/67a2085c-9103-4d7b-bd52-e2a4c1531583/images/b0baa2298a4b4a9378b7378dbef43069dc2faa3dff401ebbfbca67bad62c1076.png",
  gallery: [
    "https://static.prod-images.emergentagent.com/jobs/67a2085c-9103-4d7b-bd52-e2a4c1531583/images/e338c9ed576280b0f74565744a1016cd4fec4ad9c5cdbd40a266af220f7deff1.png",
    "https://static.prod-images.emergentagent.com/jobs/67a2085c-9103-4d7b-bd52-e2a4c1531583/images/7108ec3702b0227182c94fdb05e2e4003210c554fea4e8c92f7307e90c87e97b.png",
    "https://static.prod-images.emergentagent.com/jobs/67a2085c-9103-4d7b-bd52-e2a4c1531583/images/05438d33f3f2700755d417cf6e04a3272d648a2c4d80fa08df4f94c99a9ac173.png",
    "https://static.prod-images.emergentagent.com/jobs/67a2085c-9103-4d7b-bd52-e2a4c1531583/images/599d7be4cd9a82deb731b04767bd226079a02a08ad906dd07ebf869b323fc095.png",
    "https://static.prod-images.emergentagent.com/jobs/67a2085c-9103-4d7b-bd52-e2a4c1531583/images/72b92033c7c0bd1d6a37aaaa829d8ff2124cd33ff88312196d56dea69c586481.png",
    "https://static.prod-images.emergentagent.com/jobs/67a2085c-9103-4d7b-bd52-e2a4c1531583/images/135a12f34d1616bdb1ac1e6ad069ded4d8587dc0b14e31594e352b4b76405dec.png",
    "https://static.prod-images.emergentagent.com/jobs/67a2085c-9103-4d7b-bd52-e2a4c1531583/images/8dc98c7eff9af8bdaed8c6c2c630667bd85acbf2551a07bd9c4024d593dc0bc8.png",
    "https://static.prod-images.emergentagent.com/jobs/67a2085c-9103-4d7b-bd52-e2a4c1531583/images/cde8c03a0920211c831209c8266b9a72802baf75f03f67b8507e1d2a24872cd2.png",
    "https://static.prod-images.emergentagent.com/jobs/67a2085c-9103-4d7b-bd52-e2a4c1531583/images/d29e0ee12d21cd38b2abe5e69106eb87316173600cd709b435175505719e5594.png",
  ],
};
